
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalClosedBottom as ObiThreewayDigitalClosedBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-closed-bottom.js';
 
 
 

 
 export const ObiThreewayDigitalClosedBottom = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-closed-bottom',
   elementClass: ObiThreewayDigitalClosedBottomElement,
   events: {
     
   }
  });
 
 